<template>
    <div>
        <v-overlay :value="loading" absolute>
            <v-progress-circular indeterminate size="64" color="primary" />
        </v-overlay>
        <div v-if="loading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <app-form v-bind:parentObject="{
                data: this.formData,
                searchnew: this.search,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                errMsg: this.errMsg,
                isEdit: this.isEdit,
                pmAssessmentRecordReviewList: this.pmAssessmentRecordReviewList,
            }" v-on:input="formData = $event" v-on:save="saveHandler" v-on:error="errorHandler" />

            <div v-if="isErr">
                <app-error v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }" v-on:closeError="isErr = $event" />
            </div>
            <!-- <div v-if="isConfirm">
                <app-confirm
                v-bind:parentObject="{
                    pageTitleValue: this.pageTitleValue,
                    isConfirm: this.isConfirm,
                }"
                v-on:confirm="deleteHandler($event)"
                v-on:cancelConfirm="isConfirm = !isConfirm"
            />
            </div> -->
        </div>
    </div>
</template>

<script>
import PMAssessmentRecordForm from "../../../components/performance/assessmentrecord/Form";
import moment from 'moment';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": PMAssessmentRecordForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            id: this.$route.params.id,
            search: this.$route.params.search,
            pageTitle: this.$t('pmassementrecord.editpmassementrecord'),
            pageTitleValue: "",
            formData: {
                id: null,
                pmassessmentrecordcode: null,
                pmassessmentrecorddesc: null,
                startdate: null,
                enddate: null,
                cutoffdate: null,
                statusid: null,
                ratingtype: null,
                ratingid: null,
                ratingcode: null,
                remark: null,
                pmassecalmethodid: null,
                stamp: null,
                userid: this.$store.getters.userId,
                statusdesc:null,
                ratingtypename:null,
                calculationmethodname : null
            },
            errMsg: "",
            isErr: false,
            loading: true,
            isEdit: true,
            pmAssessmentRecordReviewList: [],
            isConfirm: false,
        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        saveHandler() {
            const vm = this;
            if (this.formData.startdate) {
                this.formData.startdate = moment(this.formData.startdate).format('YYYY-MM-DD');
            }
            if (this.formData.enddate) {
                this.formData.enddate = moment(this.formData.enddate).format('YYYY-MM-DD');
            }
            if (this.formData.cutoffdate) {
                this.formData.cutoffdate = moment(this.formData.cutoffdate).format('YYYY-MM-DD');
            }
            if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                return false;
            }
            this.$store.dispatch('put', { url: "/performanceassessmentrecord/" + vm.id, payload: this.formData })
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = res.data.error;
                    } else {
                        this.$router.push({ name: "performanceassessmentrecordlist", params: { search: this.search } });
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });

        },

        async loadPerformanceAssessmentRecordHandler() {
            this.isErr = false;
            this.errMsg = "";

            try {
                const res = await this.$store.dispatch('get', { url: `/performanceassessmentrecord/${this.id}` });

                if (res.status === 200 && res.data.rec) {
                    this.formData = { ...res.data.rec };
                    if (this.formData.startdate) {
                        this.formData.startdate = moment(this.formData.startdate).format('YYYY-MM-DD');
                    }
                    if (this.formData.enddate) {
                        this.formData.enddate = moment(this.formData.enddate).format('YYYY-MM-DD');
                    }
                    if (this.formData.cutoffdate) {
                        this.formData.cutoffdate = moment(this.formData.cutoffdate).format('YYYY-MM-DD');
                    }
                    this.formData.userid = this.$store.getters.userId;
                } else {
                    this.isErr = true;
                    console.error("data not found");
                    this.errMsg = "Record not found.";
                }
            } catch (err) {
                console.error("Error loading record:", err);
                this.isErr = true;
                this.errMsg = err.message || "Network Error";
            }
        },

        async loadPMAssessmentRecordReviewsHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: "/performanceassessmentrecordreviews/" + this.id });
                this.pmAssessmentRecordReviewList = res.data.rec;

                this.pmAssessmentRecordReviewList.forEach(item => {
                    if (item.startdate) {
                        item.startdate = moment(item.startdate).format('YYYY-MM-DD');
                    }
                    if (item.enddate) {
                        item.enddate = moment(item.enddate).format('YYYY-MM-DD');
                    }
                    //getting item data from the table, with column name as the item.name
                });
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
            }
        },
    },

    async mounted() {
        try {
            await this.loadPerformanceAssessmentRecordHandler();
            await this.loadPMAssessmentRecordReviewsHandler();
            this.loading = false; // Set loading to false after all data is loaded
        } catch (error) {
            console.error("Something went wrong during mounted:", error);
            this.isErr = true;
            this.errMsg = error;
        }
    }
};
</script>